import { Table } from "@freightsimple/ui-core/Table/Table";
import type { PaymentsInvoiceTableRow } from "./PaymentsInvoiceColumns";
import { paymentsInvoiceColumns } from "./PaymentsInvoiceColumns";

interface PaymentsPaidInvoicesTableProps {
  rows: PaymentsInvoiceTableRow[];
}

// No status/due columns: on a receipt the payment already happened, so the
// planning columns would just repeat the dialog's own status.
const columns = [
  paymentsInvoiceColumns.charge(),
  paymentsInvoiceColumns.route(),
  paymentsInvoiceColumns.amount(),
];

/** The invoices a payment covered, listed on the receipt dialog. */
export function PaymentsPaidInvoicesTable({
  rows,
}: PaymentsPaidInvoicesTableProps) {
  return (
    <Table
      columns={columns}
      data={rows}
      rowKey={(row) => row.invoice.invoiceId}
    />
  );
}
